/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 1324
// module chunks = 0